// GENERATED by scripts/build-icons.mjs from icons/database.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Database = createIcon('database', [
  ['ellipse', { cx: "12", cy: "5", rx: "9", ry: "3" }],
  ['path', { d: "M3 5V19A9 3 0 0 0 21 19V5" }],
  ['path', { d: "M3 12A9 3 0 0 0 21 12" }],
])
